import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What Clients > Schedule still reads from the workspace: the meetings and their loaders (run at start-up, from the URL and on section switch), the Book meeting form state the document-click handler and section switch reset, the client picker lists and the shared dropdown / popover helpers.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmClientsScheduleHost = Pick<
  PmWorkspaceComponent,
  | 'activeDropdown'
  | 'applyBookMeetingDurationToEnd'
  | 'bookMeetingCcChips'
  | 'bookMeetingCcDraft'
  | 'bookMeetingCcShowError'
  | 'bookMeetingClientFlyoutStyle'
  | 'bookMeetingClientId'
  | 'bookMeetingClientPanelOpen'
  | 'bookMeetingClientSearch'
  | 'bookMeetingClientsLoading'
  | 'bookMeetingDate'
  | 'bookMeetingDurationPreset'
  | 'bookMeetingEditId'
  | 'bookMeetingEnd'
  | 'bookMeetingFrom'
  | 'bookMeetingInviteFlyoutStyle'
  | 'bookMeetingInviteOptions'
  | 'bookMeetingInvitePanelOpen'
  | 'bookMeetingInviteSearch'
  | 'bookMeetingInviteSelected'
  | 'bookMeetingLocation'
  | 'bookMeetingMessage'
  | 'bookMeetingQuill'
  | 'bookMeetingStart'
  | 'bookMeetingSubject'
  | 'bookMeetingTimeFlyoutStyle'
  | 'bookMeetingTimePanel'
  | 'bookMeetingTimezone'
  | 'bookMeetingToChips'
  | 'bookMeetingToDraft'
  | 'bookMeetingToShowError'
  | 'bookMeetingType'
  | 'clientInitials'
  | 'clientNameDisplay'
  | 'clientsBookMeetingModalOpen'
  | 'clientsBookMeetingPickerRows'
  | 'clientsPickerClients'
  | 'clientsScheduleClientFilter'
  | 'clientsScheduleDateFromFilter'
  | 'clientsScheduleDateToFilter'
  | 'clientsScheduleFilterClientHighlighted'
  | 'clientsScheduleFilterClientSearch'
  | 'clientsScheduleFilterScheduledByHighlighted'
  | 'clientsScheduleGroupBy'
  | 'clientsScheduleGroupedGroups'
  | 'clientsScheduleGroupedTotalCount'
  | 'clientsScheduleLoadedFromDate'
  | 'clientsScheduleLoadedToDate'
  | 'clientsScheduleMeetings'
  | 'clientsScheduleMeetingsLoading'
  | 'clientsSchedulePageNumber'
  | 'clientsSchedulePageSize'
  | 'clientsScheduleRowActionsOpenId'
  | 'clientsScheduleRowActionsPos'
  | 'clientsScheduleScheduledByFilter'
  | 'clientsScheduleSearchQuery'
  | 'clientsScheduleTypeFilter'
  | 'clientsSectionAnchor'
  | 'clientsSwitchLoading'
  | 'closeBookMeetingClientPanel'
  | 'closeClientsScheduleRowActions'
  | 'effectiveDirectoryParentUserId'
  | 'effectiveDirectoryUserId'
  | 'findClientRowForBookMeetingPicker'
  | 'loadBookMeetingTeamInviteOptions'
  | 'loadClientsEventSchedules'
  | 'loadClientsForBookMeetingPicker'
  | 'loadClientsScheduleGrouped'
  | 'mergedDirectoryClientRowsForScheduleLabels'
  | 'navigateDdList'
  | 'openClientsBookMeetingModal'
  | 'resetBookMeetingFormForCreate'
  | 'stopProp'
  | 'stopPropAllowSpaceInFields'
  | 'teamMemberDisplayNameForUserId'
  | 'toggleDropdown'
>;

export const PM_CLIENTS_SCHEDULE_HOST = new InjectionToken<PmClientsScheduleHost>('PmClientsScheduleHost');
